import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
/**
 *
 * A Higher order component to encapsulate the wrapping of modules based on a condition
 *
 * @example
 *  <ConditionalWrapper
 *    condition={shouldWrapWithcontainer === true}
 *    wrapper={Container}
 *    otherwise={Fragment} />
 *
 */

export var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      otherwise = _ref.otherwise,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["condition", "wrapper", "otherwise", "children"]);

  return condition ? wrapper(_objectSpread({
    children: children
  }, rest)) : otherwise ? otherwise(_objectSpread({
    children: children
  }, rest)) : children;
};
ConditionalWrapper.propTypes = {
  /**
   * The condition to wrap the component based on
   */
  condition: PropTypes.bool.isRequired,

  /**
   * The wrapper element type, i.e. Component not <Component>
   * */
  wrapper: PropTypes.elementType.isRequired,

  /**
   * Optional wrapper element used if condition is false
   * */
  otherwise: PropTypes.elementType
};